/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Ad_Trim_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Event(s) trimmed to audio duration" |
*
* @param {Shortcut_Keys_Ad_Trim_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_ad_trim_success_toast = /** @type {((inputs?: Shortcut_Keys_Ad_Trim_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Ad_Trim_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenement(s) ajustes a la duree audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis(se) auf Audiodauer gekürzt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento/i ridotto/i alla durata audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("События обрезаны до аудиодлительности.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento(s) recortado(s) a la duración del audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件已剪辑至音频时长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントはオーディオの長さに合わせてトリミングされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो अवधि के अनुसार इवेंट को छोटा कर दिया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento(s) reduzido(s) à duração de áudio")
	return /** @type {LocalizedString} */ ("Event(s) trimmed to audio duration")
});